module.exports = __webpack_public_path__ + "static/media/icon-checkmark.623c42fc.svg";